module.exports = __webpack_public_path__ + "assets/img/14_1598.8e245234.jpg";